export default {
    // Common translations
    driverPerformanceFunctionTab_common_save: 'Save',
    driverPerformanceFunctionTab_common_success: 'Success',
    driverPerformanceFunctionTab_common_error: 'Error',
    driverPerformanceFunctionTab_common_warning: 'Warning',
};